<template>
<div class="chapter">
<div class="inner_page">
<h1 class="partnum"><a id="p01"></a>I</h1>
<h1 class="parttitle"><a id="page_5"></a>Preparing Your Organization for Perpetual Growth</h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_part01.vue?0b3a5a5d